import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from 'constants/query-keys';
import { ProfileService } from 'services/profile';

export const useProfile = () => {
  const userProfileQuery = useQuery(
    [QueryKeys.UserProfile],
    ProfileService.getUserProfile,
    {
      staleTime: Infinity,
      retry: false,
    }
  );

  return useMemo(
    () => ({
      userProfileQuery,
      isLoggedIn: !!userProfileQuery.data?.data.id,
      profile: userProfileQuery?.data?.data,
    }),
    [userProfileQuery]
  );
};
